import { selectAssignment } from '@redux/experiments/selectors/index';
import type { StorefrontPeaceOfMindRetestPartTwoAssignment } from '@typings/experiments';
import type { State } from 'types/redux';

/**
 * Selector to get the SF PoM Storefront Indicator - Re-retest experiment assignment
 */
export const storefrontPeaceOfMindRetestPartTwoSelector = (
	state: State,
): StorefrontPeaceOfMindRetestPartTwoAssignment => {
	const isPom = state.vendor.vendor?.settings.peaceOfMindEligible;

	if (!isPom) {
		return null;
	}

	return (
		(selectAssignment(state, ['storefrontPeaceOfMindRetestPartTwo']) as
			| StorefrontPeaceOfMindRetestPartTwoAssignment
			| undefined) ?? null
	);
};
